<template>
  <div>
    <vs-popup
      title="Atenção!"
      :active.sync="modalPlacaSubstituicao"
      @close="resetPlacaSubstituicao()"
    >
      <div>
        A placa que vai entrar não pode ser igual a que vai sair. Por favor,
        digite novamente a placa do veiculo que será substituído!
      </div>
      <div class="flex justify-end">
        <vs-button class="mt-3" @click.stop.prevent="resetPlacaSubstituicao()">
          <vs-icon icon="check"></vs-icon>
        </vs-button>
      </div>
    </vs-popup>
    <div class="vx-row" v-if="dadosProposta.dadosVeiculo">
      <div class="vx-col sm:w-1/3 w-full mb-2 card">
        <vs-card>
          <div class="flex items-baseline">
            <h4>Modelo do Veículo</h4>
            <vs-button
              v-if="carregadoFull == true"
              color="dark"
              type="gradient"
              class="ml-3 mb-2"
              @click.stop.prevent="liberaEdicaoVeiculo()"
              :disabled="verificaCamposAbrirEdicaoVeiculo()"
            >
              <vs-icon icon="edit"></vs-icon>
            </vs-button>
          </div>
          <hr class="mb-6" />
          <!--div v-if="disabilitarPorResponsavelEStatus" class="mb-2">
            <h5>
              Bloqueado até a aprovação da vistoria ou você assuma a
              resposabilidade pela vistoria
            </h5>
          </div-->

          <!-- Card Editar Veículo -->
          <div class="flex gap-1 flex-col my-4">
            <h5 v-if="showAtual">Original da proposta</h5>
            <div>
              <p><strong>Grupo:</strong> {{ dadosProposta.nomeGrupo }}</p>
            </div>
            <div>
              <p>
                <strong>Marca:</strong>
                {{ dadosProposta.dadosVeiculo.veiculoMarca }}
              </p>
            </div>
            <div>
              <p>
                <strong>Ano do Modelo:</strong>
                {{
                  dadosProposta.dadosVeiculo.anoModelo == 32000
                    ? '0KM'
                    : dadosProposta.dadosVeiculo.anoModelo
                }}
              </p>
            </div>
            <div>
              <p>
                <strong>Modelo:</strong>
                {{ dadosProposta.dadosVeiculo.veiculoModelo }}
              </p>
            </div>
            <div>
              <p>
                <strong>Ano de Fabricação:</strong>
                {{
                  dadosProposta.dadosVeiculo.anoFabricacao == 32000
                    ? '0KM'
                    : dadosProposta.dadosVeiculo.anoFabricacao
                }}
              </p>
            </div>
          </div>

          <div class="flex gap-1 flex-col my-4" v-if="showAtual">
            <h5>Atual</h5>
            <div>
              <p><strong>Grupo:</strong> {{ form.veiculo.labeGrupo }}</p>
            </div>
            <div>
              <p>
                <strong>Marca:</strong>
                {{ form.veiculo.marca.valor }}
              </p>
            </div>
            <div>
              <p>
                <strong>Ano do Modelo:</strong>
                {{ form.veiculo.anoModelo }}
              </p>
            </div>
            <div>
              <p>
                <strong>Modelo:</strong>
                {{ form.veiculo.modelo.valor }}
              </p>
            </div>
            <div>
              <p>
                <strong>Ano de Fabricação:</strong>
                {{ form.veiculo.anoFabricacao }}
              </p>
            </div>
          </div>

          <!-- Campos de edição do veículo -->

          <div v-if="podeEditarVeiculo">
            <!-- Grupo -->
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <label for="idGrupo" key="idGrupo" class="vs-select--label"
                >Grupo</label
              >
              <v-select
                :options="gruposPorTipo"
                name="Grupo"
                label="label"
                id="idGrupo"
                v-model="form.veiculo.idGrupo"
                @input="
                  selecionaTipo(),
                    preencheMarca(),
                    verificaSeGrupoPermiteComplementos(form.veiculo.idGrupo),
                    emitChangedForm('idGrupo', form.veiculo)
                "
                class="select-large w-full"
                :reduce="(item) => item.id"
                v-validate="{ required: true }"
                :state="validateState('Grupo')"
                :danger="validateClass('Grupo')"
                :disabled="verificarPermissaoEditarGrupo()"
              ></v-select>
            </div>

            <!-- Marca -->
            <div
              v-if="form.somenteAgregado == false && form.veiculo.idGrupo"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <label for="marca" key="marca" class="vs-select--label"
                >Marca</label
              >
              <v-select
                :options="marcas"
                name="Marca"
                label="text"
                id="marca"
                v-model="form.veiculo.marca"
                @input="
                  resetaModeloCompleto();
                  preencheAnos(),
                    emitChangedForm('marca', form.veiculo),
                    (auxMarca = form.veiculo.marca);
                "
                class="select-large w-full"
                :reduce="(item) => item.value"
                v-validate="{ required: true }"
                :state="validateState('Marca')"
                :danger="validateClass('Marca')"
                :disabled="
                  disabilitarPorResponsavelEStatus ||
                  verificarPermissaoEditarGrupo()
                "
              ></v-select>
            </div>

            <!-- Marca do Agregado -->
            <div
              v-else-if="form.somenteAgregado && form.veiculo.idGrupo"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <vs-input
                class="w-full"
                label="Marca do Agregado"
                name="Marca do Agregado"
                v-model="form.veiculo.marca"
                @change="emitChangedForm('marca', form.veiculo)"
                v-validate="{ min: 5 }"
                :state="validateState('Marca do Agregado')"
                :danger="validateClass('Marca do Agregado')"
                :disabled="disabilitarPorResponsavelEStatus"
              />
            </div>

            <!-- Ano Geral -->
            <div
              v-if="form.somenteAgregado == false && form.veiculo.marca"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <label for="anoGeral" key="_anoGeral" class="vs-select--label"
                >Ano Modelo</label
              >
              <v-select
                :options="anosModelo"
                name="anoGeral"
                label="text"
                id="anoGeral"
                v-model="form.veiculo.anoGeral"
                @input="
                  selecionaAnoModelo(),
                    emitChangedForm('anoGeral', form.veiculo)
                "
                class="select-large w-full"
                :reduce="(item) => item.value"
                v-validate="{ required: true }"
                :state="validateState('Ano Modelo')"
                :danger="validateClass('Ano Modelo')"
                :disabled="disabilitarPorResponsavelEStatus"
              ></v-select>
            </div>
            <div
              class="vx-col sm:w-1/1 w-full mb-2"
              v-else-if="form.somenteAgregado && form.veiculo.marca"
            >
              <vs-input
                class="w-full"
                label="Ano Modelo"
                name="Ano Modelo"
                v-model="form.veiculo.anoModelo"
                v-mask="'####'"
                v-validate="{ min: 4, max: 4, required: true }"
                :state="validateState('Ano Modelo')"
                :danger="validateClass('Ano Modelo')"
                @change="emitChangedForm('anoModelo', form.veiculo)"
              />
            </div>

            <!-- Modelos -->
            <div
              v-if="form.somenteAgregado == false && form.veiculo.anoModelo"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <label for="modelo" key="modelo" class="vs-select--label"
                >Modelos</label
              >
              <v-select
                :options="modelos"
                name="Modelos"
                label="text"
                id="modelo"
                v-model="form.veiculo.modelo"
                @input="
                  emitChangedForm('modelo', form.veiculo),
                    (form.veiculo.anoFabricacao = null)
                "
                class="select-large w-full"
                :reduce="(item) => item.value"
                v-validate="{ required: true }"
                :state="validateState('Modelos')"
                :danger="validateClass('Modelos')"
                :disabled="disabilitarPorResponsavelEStatus"
              ></v-select>
            </div>

            <!-- modelo Agregado -->
            <div
              v-else-if="form.somenteAgregado && form.veiculo.anoGeral"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <vs-input
                class="w-full"
                label="Modelo do Agregado"
                name="Modelo do Agregado"
                v-model="form.veiculo.modelo"
                @change="emitChangedForm('modelo', form.veiculo)"
                v-validate="{ min: 5 }"
                :state="validateState('Modelo do Agregado')"
                :danger="validateClass('Modelo do Agregado')"
                :disabled="disabilitarPorResponsavelEStatus"
              />
            </div>

            <!-- ano fabricação -->
            <div
              v-if="form.somenteAgregado == false && form.veiculo.modelo"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <label for="restricoesSelecionadas" class="vs-select--label"
                >Ano Fabricação</label
              >
              <v-select
                :options="anosFabricacao"
                name="Ano Fabricação"
                label="text"
                id="restricoesSelecionadas"
                v-model="form.veiculo.anoFabricacao"
                @input="
                  emitChangedForm('anoFabricacao', form.veiculo),
                    selecionaGruposFipe()
                "
                class="select-large w-full"
                :reduce="(item) => item.value"
                v-validate="{ required: true }"
                :state="validateState('Ano Fabricação')"
                :danger="validateClass('Ano Fabricação')"
                :disabled="disabilitarPorResponsavelEStatus"
              ></v-select>
            </div>
            <div
              class="vx-col sm:w-1/1 w-full mb-2"
              v-else-if="form.somenteAgregado && form.veiculo.modelo"
            >
              <vs-input
                class="w-full"
                label="Ano Fabricação"
                name="Ano Fabricação"
                v-model="form.veiculo.anoFabricacao"
                v-mask="'####'"
                v-validate="{ min: 4, max: 4, required: true }"
                :state="validateState('Ano Fabricação')"
                :danger="validateClass('Ano Fabricação')"
                @change="
                  emitChangedForm('anoFabricacao', form.veiculo),
                    selecionaGruposFipe()
                "
              />
            </div>

            <vs-alert v-if="!form.veiculo.idGrupo" title="Atenção!" clas="mb-2"
              >Para alterar dados de Marca, Modelo e Ano é necessário selecionar
              o Grupo.</vs-alert
            >

            <div class="flex justify-end mt-3">
              <vs-button
                type="gradient"
                @click.stop.prevent="concluirEdicaoVeiculo()"
                :disabled="verificaCamposParaEdicao()"
                >Editar Veículo</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
      <div class="vx-col sm:w-2/3 w-full mb-2 card">
        <vs-row class="sm:w-1/1 w-full mb-2">
          <vs-col
            v-if="dadosProposta.somenteAgregado == false"
            class="text-right"
          >
            <vs-button
              v-if="this.permiteImplemento"
              color="primary"
              type="gradient"
              class="mb-2 text-white forceWhite mr-3"
              @click.stop.prevent="
                abrirModalComplemento(),
                  (tipoConfiguracaoCaminhao = 'implemento'),
                  (form.implemento = true)
              "
            >
              <vs-icon icon="add" class="mr-3"></vs-icon>
              Adicionar Implemento
            </vs-button>
            <vs-button
              v-if="this.permiteAgregado"
              color="primary"
              type="gradient"
              class="mb-2 text-white forceWhite"
              @click.stop.prevent="
                abrirModalComplemento(),
                  (tipoConfiguracaoCaminhao = 'agregado'),
                  (abrirPopUpTelaCheia = true),
                  (addComplementoEdicao = true),
                  (form.agregado = true)
              "
            >
              <vs-icon icon="add" class="mr-3"></vs-icon>
              Adicionar Agregado
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-card>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="
                  dadosProposta.tipoProposta == 'Substituição'
                    ? 'Placa que vai entrar'
                    : 'Placa'
                "
                v-mask="'AAA-#XX#'"
                v-model="form.placa"
                name="Placa"
                @change="emitChangedForm('placa', form.placa)"
                @keyup.native="_consultaPlaca($event)"
                v-validate="{ required: true, min: 8 }"
                :state="validateState('Placa')"
                :danger="validateClass('Placa')"
                :disabled="permiteEditarPlaca"
              />
            </div>
            <div
              class="vx-col sm:w-1/2 w-full mb-2"
              v-if="dadosProposta.tipoProposta == 'Substituição'"
            >
              <vs-input
                class="w-full upeercase..."
                label="Placa que vai sair"
                v-mask="'AAA-#XX#'"
                v-model="form.placaSubstituicao"
                name="Placa de Substituição"
                @change="verificaPlacaSubstituicao()"
                v-validate="{ required: true, min: 8 }"
                :state="validateState('Placa de Substituição')"
                :danger="validateClass('Placa de Substituição')"
              />
            </div>
            <div
              v-if="$can('Editar Classificações', 'Veículos')"
              class="vx-col sm:w-1/2 w-full mb-2"
            >
              <label class="vs-select--label">Classificação</label>
              <v-select
                :options="listClassificacoes"
                name="Classificação"
                label="nome"
                id="Classificação"
                v-model="form.veiculo.idClassificacao"
                @input="
                  emitChangedForm(
                    'idClassificacao',
                    form.veiculo.idClassificacao,
                  )
                "
                class="select-large w-full"
                :reduce="(item) => item.idClassificacao"
                v-validate="{ required: true }"
                :state="validateState('Classificação')"
                :danger="validateClass('Classificação')"
              ></v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                label="Renavam"
                type="number"
                v-model="form.renavam"
                name="Renavam"
                @change="emitChangedForm('renavam', form.renavam)"
                v-validate="{ required: true }"
                :state="validateState('Renavam')"
                :danger="validateClass('Renavam')"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                label="Chassi"
                v-model="form.chassi"
                name="Chassi"
                @change="emitChangedForm('chassi', form.chassi)"
                @input="chassiToUpperCase(form.chassi)"
                v-validate="{ required: true, min: 17, max: 17 }"
                :state="validateState('Chassi')"
                :danger="validateClass('Chassi')"
                :disabled="permiteEditarPlaca"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                class="w-full"
                label="KM"
                type="number"
                v-model="form.km"
                name="KM"
                v-mask="'##########'"
                @change="emitChangedForm('km', form.km)"
                v-validate="{ required: true, max: 10 }"
                :state="validateState('KM')"
                :danger="validateClass('KM')"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                v-if="exibeCilindrada || Boolean(form.cilindradas)"
                class="w-full"
                type="number"
                label="Cilindradas"
                v-model="form.cilindradas"
                name="Cilindradas"
                @change="emitChangedForm('cilindradas', form.cilindradas)"
                v-validate="{ required: true }"
                :state="validateState('Cilindradas')"
                :danger="validateClass('Cilindradas')"
              />
              <vs-input
                v-else
                class="w-full"
                label="Portas"
                type="number"
                v-model="form.qtdPortas"
                name="Portas"
                id="Portas"
                @change="emitChangedForm('qtdPortas', form.qtdPortas)"
                v-validate="{ required: true, max: 1 }"
                :state="validateState('Portas')"
                :danger="validateClass('Portas')"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                class="w-full"
                label="Ano CRLV"
                type="number"
                v-model="form.anoExercicioDut"
                name="Ano CRLV"
                @change="
                  emitChangedForm('anoExercicioDut', form.anoExercicioDut)
                "
                v-validate="{ required: true }"
                :state="validateState('Ano CRLV')"
                :danger="validateClass('Ano CRLV')"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label
                for="restricoesSelecionadas"
                key="restricoesSelecionadas"
                class="vs-select--label"
                >Estado do Pneu</label
              >
              <v-select
                :options="estadoPneus"
                name="Estado do Pneu"
                label="item"
                id="restricoesSelecionadas"
                v-model="form.estadoPneu"
                @input="emitChangedForm('estadoPneu', form.estadoPneu)"
                class="select-large w-full"
                :reduce="(item) => item"
                v-validate="{ required: true }"
                :state="validateState('Estado do Pneu')"
                :danger="validateClass('Estado do Pneu')"
              ></v-select>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label
                for="combustivel"
                key="combustivel"
                class="vs-select--label"
                >Combustivel</label
              >
              <v-select
                :options="combustiveis"
                name="Combustivel"
                label="label"
                id="combustivel"
                v-model="form.combustivel"
                @input="emitChangedForm('combustivel', form.combustivel)"
                class="select-large w-full"
                :reduce="(item) => item.id"
                v-validate="{ required: true }"
                :state="validateState('Combustivel')"
                :danger="validateClass('Combustivel')"
              ></v-select>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for="cor" key="cor" class="vs-select--label">Cor</label>
              <v-select
                :options="cores"
                name="Cor"
                label="label"
                id="cor"
                v-model="form.cor"
                @input="emitChangedForm('cor', form.cor)"
                class="select-large w-full"
                :reduce="(item) => item.id"
                v-validate="{ required: true }"
                :state="validateState('Cor')"
                :danger="validateClass('Cor')"
              ></v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="tipoCambio" key="tipoCambio" class="vs-select--label"
                >Tipo de Câmbio</label
              >
              <v-select
                :options="tipoCambioOpcoes"
                name="Tipo de Câmbio"
                id="tipoCambio"
                v-model="form.veiculo.tipoCambio"
                v-validate="{ required: true }"
                @input="emitChangedForm('tipoCambio', form.veiculo.tipoCambio)"
                :state="validateState('Tipo de Câmbio')"
                :class="validateClass('Tipo de Câmbio')"
              ></v-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label
                for="numeroMotor"
                key="numeroMotor"
                class="vs-select--label"
                >Número do Motor</label
              >
              <vs-input
                class="w-full"
                id="numeroMotor"
                style="text-transform: uppercase"
                v-model="form.veiculo.numeroMotor"
                name="Número do Motor"
                @change="
                  emitChangedForm('numeroMotor', form.veiculo.numeroMotor)
                "
                v-validate="{ required: true, alpha_num: true }"
                :state="validateState('Número do Motor')"
                :danger="validateClass('Número do Motor')"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label
                for="tipoEstacionamento"
                key="tipoEstacionamento"
                class="vs-select--label"
                >Onde o veículo é estacionado normalmente?</label
              >
              <v-select
                :options="listLocaisEstacionamento"
                name="Local de Estacionamento"
                id="tipoEstacionamento"
                label="label"
                v-model="form.veiculo.idTipoEstacionamento"
                v-validate="{ required: true }"
                :reduce="(item) => item.id"
                @input="
                  emitChangedForm(
                    'tipoEstacionamento',
                    form.veiculo.idTipoEstacionamento,
                  )
                "
                :state="validateState('Local de Estacionamento')"
                :class="validateClass('Local de Estacionamento')"
              ></v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <h4 class="mb-3 mt-6">
                Franquia
                <vs-button
                  v-if="
                    $can('Permitir editar cota de participação', 'Cotações')
                  "
                  color="dark"
                  type="gradient"
                  class="ml-2 mb-2"
                  @click.stop.prevent="forcaAtualizacaoCota()"
                >
                  <vs-icon icon="edit"></vs-icon>
                </vs-button>
              </h4>
              <hr class="mb-6" />
            </div>
          </div>
          <div class="vx-row">
            <div :class="`vx-col sm:w-1/2 w-full mb-2`">
              <vs-input
                class="w-full"
                label="Franquia (%)"
                type="number"
                v-model="form.valorCotaParticipacao"
                :disabled="!form.forcarAtualizarCotaManual"
                name="Franquia"
                @change="
                  emitChangedForm(
                    'valorCotaParticipacao',
                    form.valorCotaParticipacao,
                  )
                "
                v-validate="{ required: true }"
                :state="validateState('Franquia')"
                :danger="validateClass('Franquia')"
              />
            </div>
            <div :class="`vx-col sm:w-1/2 w-full mb-2`">
              <label for class="vs-input--label">Valor Mínimo (R$)</label>
              <money
                class="vs-inputx vs-input--input normal"
                name="Valor Mínimo"
                id="Valor Mínimo"
                v-model="form.valorParticipacaoMinimo"
                :disabled="!form.forcarAtualizarCotaManual"
                @input="
                  emitChangedForm(
                    'valorParticipacaoMinimo',
                    form.valorParticipacaoMinimo,
                  )
                "
                v-validate="{ required: true }"
                :state="validateState('Valor Mínimo')"
                :danger="validateClass('Valor Mínimo')"
                v-bind="money"
              ></money>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <h4 class="mb-3 mt-6">Valores de Cobertura</h4>
              <hr class="mb-6" />
            </div>
          </div>
          <div class="vx-row">
            <div
              :class="`vx-col ${
                form.codTipoVeiculo !== 3 ? 'sm:w-1/2' : 'sm:w-1/3'
              } w-full mb-2`"
            >
              <label for class="vs-input--label">Preço FIPE</label>
              <money
                class="vs-inputx vs-input--input normal"
                name="Preço FIPE do Caminhão"
                id="Preço FIPE do Caminhão"
                v-model="form.veiculo.valorFipe"
                @input="emitChangedForm('valorFipe', form.veiculo.valorFipe)"
                v-validate="{ required: true }"
                :state="validateState('Preço FIPE do Caminhão')"
                :danger="validateClass('Preço FIPE do Caminhão')"
                v-bind="money"
                :disabled="permiteAlterarValorFipe"
              ></money>
            </div>

            <div
              v-if="form.codTipoVeiculo === 3 && !dadosProposta.somenteAgregado"
              :class="`vx-col ${
                form.codTipoVeiculo !== 3 ? 'sm:w-1/2' : 'sm:w-1/3'
              } w-full mb-2`"
            >
              <label for class="vs-input--label">Valor total do conjunto</label>
              <money
                class="vs-inputx vs-input--input normal"
                name="Valor total do conjunto"
                id="Valor total do conjunto"
                v-model="form.valorTotalConjunto"
                @input="
                  emitChangedForm('valorTotalConjunto', form.valorTotalConjunto)
                "
                v-validate="{ required: true }"
                :state="validateState('Valor total do conjunto')"
                :danger="validateClass('Valor total do conjunto')"
                v-bind="money"
                :disabled="permiteAlterarValorConjunto"
              ></money>
            </div>

            <div
              :class="`vx-col ${
                form.codTipoVeiculo !== 3 ? 'sm:w-1/2' : 'sm:w-1/3'
              } w-full mb-2`"
            >
              <label for class="vs-input--label"
                >Digite o valor que será coberto</label
              >
              <money
                class="vs-inputx vs-input--input normal"
                name="Valor de Cobertura"
                id="Valor de Cobertura"
                v-model="form.veiculo.valorCobertura"
                @blur.native="
                  emitChangedForm('valorCobertura', form.veiculo.valorCobertura)
                "
                v-validate="{ required: true, min: 0.01 }"
                :state="validateState('Valor de Cobertura')"
                :danger="validateClass('Valor de Cobertura')"
                v-bind="money"
                :disabled="permiteAlterarValorCobertura"
              ></money>
            </div>
          </div>

          <!-- Notasical veículo zero -->
          <div v-if="form.isZero && verificaEmpresa()" class="vx-row">
            <div
              v-if="!verificaEmpresa()"
              :class="`vs-col w-full mb-6 ${
                verificaEmpresa() ? 'sm:w-1/3' : 'sm:w-1/4'
              }`"
            >
              <vs-input
                class="w-full"
                label="Nota Fiscal"
                v-model="form.nf"
                @input="emitChangedForm('nf', form.nf)"
                name="Nota Fiscal"
                id="Nota Fiscal"
                v-validate="{ required: true }"
                :state="validateState('Nota Fiscal')"
                :danger="validateClass('Nota Fiscal')"
              />
            </div>

            <div
              :class="`vs-col w-full mb-6 ${
                verificaEmpresa() ? 'sm:w-1/3' : 'sm:w-1/4'
              }`"
            >
              <!-- <label for class="vs-input--label"
                >Data de Vencimento dsfsdf</label
              >
              <datepicker
                class="inputData"
                :format="'dd/MM/yyyy'"
                label="DD/MM/YYYY"
                v-model="form.dataNf"
                @input="emitChangedForm('dataNf', form.dataNf)"
                name="Data de Vencimento Nota"
                id="Data de Vencimento Nota"
                v-validate="{ required: true }"
                :state="validateState('Data de Vencimento Nota')"
                :danger="validateClass('Data de Vencimento Nota')"
              ></datepicker> -->

              <vs-input
                class="w-full"
                label="Data de saída da NF"
                v-model="form.dataNf"
                v-mask="'##/##/####'"
                name="Data de saída da NF"
                id="dataSaidaNF"
                @change="
                  emitChangedForm('dataNf', form.dataNf),
                    emitChangedForm('dataNf', form.dataNf, 'dadosGerais')
                "
                @keyup.native="keyMonitorDataNF"
                v-validate="'date_format:dd/MM/yyyy'"
                :state="validateState('Data de saída da NF')"
                :danger="validateClass('Data de saída da NF')"
                :disabled="naoPodeEditarDataSaidaNF"
              />
            </div>

            <div
              :class="`vs-col mb-6 ${
                verificaEmpresa() ? 'sm:w-1/3' : 'sm:w-1/4'
              }`"
            >
              <label for class="vs-input--label">Valor Nota</label>
              <money
                class="vs-inputx vs-input--input normal"
                name="Valor Nota"
                id="Valor Nota"
                v-model="form.valorNf"
                @input="emitChangedForm('valorNf', form.valorNf)"
                v-validate="{ required: true }"
                :state="validateState('Valor Nota')"
                :danger="validateClass('Valor Nota')"
                v-bind="money"
                :disabled="naoPodeEditarDataSaidaNF"
              ></money>
            </div>

            <div
              :class="`vx-col w-full mb-6 ${
                verificaEmpresa() ? 'sm:w-1/3' : 'sm:w-1/4'
              }`"
            >
              <vs-input
                class="w-full"
                label="Chassi"
                v-model="form.chassi"
                @change="emitChangedForm('chassi', form.chassi)"
                @input="chassiToUpperCase(form.chassi)"
                name="Chassi"
                id="Chassi"
                v-validate="{ required: true, min: 17 }"
                :state="validateState('Chassi')"
                :danger="validateClass('Chassi')"
                :disabled="naoPodeEditarDataSaidaNF"
              />
            </div>
          </div>
          <tr
            v-if="
              dadosProposta.idStatus != 4 &&
              (resposavelVistoria || !statusAguardandoAprovacao)
            "
          >
            <td
              v-if="!dadosProposta.somenteAgregado"
              colspan="2"
              class="text-center"
            >
              <button
                class="vs-component vs-button vs-button-success vs-button-gradient mb-4"
                @click.stop.prevent="buscarFipeAtualizada()"
                type="gradient"
              >
                Forçar Atualização de FIPE
              </button>
            </td>
          </tr>
        </vs-card>

        <!-- AAImplementos -->
        <vs-card v-if="form.implementos.length > 0">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <h4 class="mb-3 mt-6">Implementos</h4>
            <hr class="" />
            <vs-list>
              <vs-list-item
                v-for="(item, index) in form.implementos"
                :key="index"
                :title="definirTituloListaComplementos(item)"
                :subtitle="definirSubTituloListaComplementos(item)"
              >
                <div class="vs-row" style="display: flex; gap: 2px">
                  <vs-button
                    color="primary"
                    type="border"
                    icon="edit"
                    @click.stop.prevent="
                      editarComplemento({ ...item, index: index }),
                        (tipoConfiguracaoCaminhao = 'implemento')
                    "
                  >
                  </vs-button>
                  <vs-button
                    color="danger"
                    type="border"
                    icon="delete"
                    @click.stop.prevent="
                      excluirComplemento({ ...item, index: index }),
                        (tipoConfiguracaoCaminhao = 'implemento'),
                        temComplemento()
                    "
                  >
                  </vs-button>
                </div>
              </vs-list-item>
            </vs-list>
          </div>
        </vs-card>
        <!-- <vs-card v-else>
          <div>
          <vs-alert style="height: auto" active="true" color="danger">
            Nenhum implemento adicionado
          </vs-alert>
        </div>
        </vs-card> -->

        <!-- AAgregados -->
        <vs-card v-if="form.agregados.length > 0">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <h4 class="mb-3 mt-6">Agregados</h4>
            <hr class="" />
            <vs-list>
              <vs-list-item
                v-for="(item, index) in form.agregados"
                :key="index"
                :title="definirTituloListaComplementos(item)"
                :subtitle="definirSubTituloListaComplementos(item)"
              >
                <div class="vs-row" style="display: flex; gap: 2px">
                  <vs-button
                    color="primary"
                    type="border"
                    icon="edit"
                    @click.stop.prevent="
                      editarComplemento({ ...item, index: index }),
                        (tipoConfiguracaoCaminhao = 'agregado'),
                        (abrirPopUpTelaCheia = true)
                    "
                  >
                  </vs-button>
                  <vs-button
                    color="danger"
                    type="border"
                    icon="delete"
                    @click.stop.prevent="
                      excluirComplemento({ ...item, index: index }),
                        (tipoConfiguracaoCaminhao = 'agregado'),
                        temComplemento()
                    "
                  >
                  </vs-button>
                </div>
              </vs-list-item>
            </vs-list>
          </div>
        </vs-card>
      </div>
    </div>

    <!-- modal Configurações caminhão -->
    <vs-popup
      :title="`Adicionar ${tipoConfiguracaoCaminhao}`"
      :active.sync="modalComplemento"
      :fullscreen="abrirPopUpTelaCheia"
      @close="
        modalComplemento = false;
        abrirPopUpTelaCheia = false;
        resetFormComplemento = true;
        temComplemento();
      "
    >
      <!-- criar componete form Agregado -->
      <FormComplemento
        :idEmpresa="this.dadosProposta.idEmpresa"
        :idGrupoVeiculo="this.dadosProposta.idGrupo"
        :dadosComplemento="complementoSelecionado"
        :resetFormComplemento="resetFormComplemento"
        :exibirFormCompleto="exibirFormComplementoCompleto"
        :tipoComplemento="tipoConfiguracaoCaminhao"
        :dadosCliente="this.dadosProposta.dadosCliente"
        :dadosGerais="this.dadosProposta"
        :editarComplemento="false"
        :addComplementoEdicao="addComplementoEdicao"
        :idRegional="idRegional"
        @adicionar="adicionarComplemento"
        @atualizar="AtualizarComplemento"
      >
      </FormComplemento>
    </vs-popup>

    <vs-popup
      title="Atenção esta propota tem complementos"
      :active.sync="modalConfirmExclusaoComplemento"
    >
      O Grupo selecionado não permite Agregados/Implementos Deseja excluir os
      existentes nessa proposta?
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="(modalConfirmExclusaoComplemento = false), restauraGrupo()"
            type="gradient"
            color="success"
            class="mt-5"
            style="margin-right: 5px"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Não
          </vs-button>
          <vs-button
            @click="excluirComplementos()"
            type="gradient"
            color="success"
            class="mt-5"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Sim
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Modal placa recusada -->
    <vs-popup
      title="Placa Recusada"
      :active.sync="modalPlacaRecusada"
      @close="modalPlacaRecusada = false"
    >
      Encontramos uma cotação para essa placa:

      <ul class="mt-2 mb-2">
        <li>
          <b
            ><strong>Placa: {{ form.placa }}</strong></b
          >
        </li>
        <li>
          <b
            >Regional: <strong>{{ regionalConsultorPlaca }}</strong>
          </b>
        </li>
        <li>
          <b
            >consultor: <strong>{{ nomeConsultorPlaca }}</strong></b
          >
        </li>
      </ul>

      informe outra placa para dar continuidade
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="modalPlacaRecusada = false"
            type="gradient"
            color="warning"
            class="mt-5"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Entendi
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Modal alerta mudança data nf -->
    <!-- Modal placa recusada -->
    <vs-popup
      title="Atenção"
      :active.sync="modalAlteracaoDataNf"
      @close="resetTrocaDataNF"
    >
      <p v-if="msgAlertaResetFotos">
        <span>
          Ao Alterar a data de saída da nota físcal, o processo de vistoria
          poderá ser modificado. Para o veículo ser consíderado novo a data de
          saída do veículo da concecionária deve ter no maxímo 3 dias úteis de
          de diferença. Deseja proseguir?
        </span>
      </p>

      <!-- <p v-if="confirmacaoResetVistoria">
        <span>
          Ao clicar no botão sim, você concorda que será necessário refazer a
          vistoria. Esse processo é irreversível, todas as fotos serão apagadas
          e a proposta será alterada para o status em "processo de vistoria".
        </span>
      </p> -->

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="resetTrocaDataNF"
            type="gradient"
            color="primary"
            class="mt-5 mr-2"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Não
          </vs-button>
          <vs-button
            @click="resetFotosVistoria"
            type="gradient"
            color="danger"
            class="mt-5"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Sim
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- modal data saída nf invalido -->
    <vs-popup
      title="Data de saída da nota fiscal inválida"
      :active.sync="modalInfoDataSaidaNf"
      @close="modalInfoDataSaidaNf = false"
    >
      A data de saída da nota físcal é inválida, a saída do veículo deve ter no
      máximo 3 dias úteis.

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="modalInfoDataSaidaNf = false"
            type="gradient"
            color="warning"
            class="mt-5"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Entendi
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- --------------------START MODAL GRUPOS-------------------------- -->
    <vs-popup
      :title="'Grupo de Veículos'"
      :active.sync="modalGrupos"
      button-close-hidden
      @close="modalGrupos = true"
    >
      <vs-list>
        <vs-list-item
          v-for="(grupoTipo, index) in gruposEncontrados"
          :key="index"
          :title="grupoTipo.label"
          :subtitle="grupoTipo.descricaoProdutos"
        >
          <vs-radio
            color="rgb(47,53,102)"
            v-model="grupoEncontradoSelecionado"
            :vs-value="grupoTipo"
          ></vs-radio>
        </vs-list-item>
      </vs-list>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-end">
          <vs-button
            @click.stop.prevent="selecionaGrupoEncontrado()"
            color="primary"
            type="gradient"
            class="mr-3 mt-2 mb-2"
            >Escolher</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Veículo Sem grupo"
      :active.sync="veiculoSemGrupo"
    >
      <vs-alert
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        Não foi possível realizar sua cotação, pois o modelo deste veículo não
        está vinculado a um grupo, favor entrar em contato com seu líder.
      </vs-alert>
    </vs-popup>
    <!-- --------------------END MODAL GRUPOS-------------------------- -->
  </div>
</template>

<script>
import service from './../../services';
import functions from './../../utils/functions';
import locale from './../../locale';
import { Money } from 'v-money';
import vSelect from 'vue-select';
import FormComplemento from '../forms/FormComplemento.vue';
import jwt from 'jsonwebtoken';
import { consultaPlaca } from '../../services/cotacao';
import dateConversion from '../../utils/dateConversion';
import estacionamentoService from '../../services/estacionamento';
import notify from '../../utils/notify';

export default {
  props: [
    'dadosProposta',
    'formulario',
    'grupos',
    'combustiveis',
    'cores',
    'estadoCliente',
    'cidadeCliente',
    'idUsuario',
    'permitePlacaRepetida',
    'carregadoFull',
    'idRegional',
  ],
  watch: {
    dadosProposta() {
      this.preencheForm();
    },
    grupos() {
      this.filtraGruposPorTipo();
    },
    'form.implementos': function (value) {
      if (!value) this.form.implementos = [];
    },
    'form.agregados': function (value) {
      if (!value) this.form.agregados = [];
      this.emitChangedForm('agregados', value);
    },
    async cidadeCliente(value, oldValue) {
      if (value || value == '') this.cidade = value;

      if (value === null || value === undefined) {
        this.cidade =
          this.dadosProposta.dadosCliente.cidade ||
          this.formulario.dadosCliente.cidade;
      }

      if (value != oldValue && oldValue != null) {
        await this.atualizarCotaParticipacao();
      }
    },
    async estadoCliente(value, oldValue) {
      if (value) this.estado = value;
      if (!value) {
        this.estado =
          this.dadosProposta.dadosCliente.estado ||
          this.formulario.dadosCliente.estado;
      }

      if (value != oldValue && oldValue != null) {
        await this.atualizarCotaParticipacao();
      }
    },
    'form.agregado': function () {
      this.emitChangedForm('agregado', this.form.agregado);
    },
    'form.implemento': function () {
      this.emitChangedForm('implemento', this.form.implemento);
    },
    'form.veiculo.idGrupo': function (newValue, oldValue) {
      if (this.grupoSelecionado) {
        this.permiteAgregado = this.grupoSelecionado.permiteAgregado;
        this.permiteImplemento = this.grupoSelecionado.permiteImplemento;
      }

      if (oldValue && (this.permiteAgregado || this.permiteImplemento)) {
        this.idGrupoAux = oldValue;
      }
    },
  },
  computed: {
    resposavelVistoria() {
      const { idResponsavel } = this.dadosProposta;
      return idResponsavel === this.idUsuario;
    },
    statusAguardandoAprovacao() {
      const { nomeStatus, idStatus } = this.dadosProposta;
      return (
        nomeStatus === 'Aguardando Aprovação' &&
        (idStatus === 3 || idStatus === 7)
      );
    },
    disabilitarPorResponsavelEStatus() {
      return this.statusAguardandoAprovacao && !this.resposavelVistoria;
    },
  },
  components: {
    Money,
    'v-select': vSelect,
    FormComplemento,
  },
  data() {
    return {
      cidade: null,
      estado: null,
      addComplementoEdicao: true,
      abrirPopUpTelaCheia: false,
      tipoConfiguracaoCaminhao: null,
      precoVeiculo: 0,
      exibirValorTotalConjunto: true,
      exibirformImplementoCompleto: true,
      exibirFormComplementoCompleto: true,
      implementoSelecionado: {},
      agregadoSelecionado: {},
      complementoSelecionado: {},
      modalImplemento: false,
      resetFormImplemento: false,
      modalComplemento: false,
      resetFormComplemento: false,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      exibeCilindrada: false,
      forcarAtualizacao: false,
      codigoTabelaReferencia: null,
      tiposVeiculos: [],
      marcas: [],
      modelos: [],
      modelosAux: [],
      anosModelo: [],
      anosFabricacao: [],
      tipoCambioOpcoes: ['Automático', 'Manual'],
      estadoPneus: ['Ruim', 'Regular', 'Bom', 'Novo'],
      codTipoVeiculo: null,
      gruposPorTipo: [],
      codTipoVeiculoAux: null,
      grupoSelecionado: null,
      permiteAgregado: null,
      permiteImplemento: null,
      form: {
        idProposta: null,
        placa: null,
        placaSubstituicao: null,
        renavam: null,
        chassi: null,
        km: null,
        qtdPortas: null,
        anoExercicioDut: null,
        estadoPneu: null,
        combustivel: null,
        cor: null,
        cilindradas: null,
        implementos: [],
        agregados: [],
        agregadosDeletados: [],
        implementosDeletados: [],
        valorCotaParticipacao: null,
        valorParticipacaoMinimo: null,
        forcarAtualizarCotaManual: false,
        forcarRecalculodeCotaParticipacao: false,
        veiculo: {
          idGrupo: null,
          tipoVeiculo: null,
          codigoMarca: null,
          codigoModelo: null,
          anoGeral: null,
          anoModelo: null,
          anoFabricacao: null,
          codigoTipoCombustivel: null,
          combustivel: '',
          marca: null,
          modelo: null,
          codigoFipe: '',
          ano: null,
          resultFipe: {},
          tipoCambio: null,
          numeroMotor: null,
          idClassificacao: null,
          idTipoEstacionamento: null,
        },
      },
      idGrupoAux: null,
      auxMarca: null,
      dicionarioCombustivelFipe: {},
      modalConfirmExclusaoComplemento: false,
      excluirAgregados: false,
      excluirImplementos: false,
      modalPlacaSubstituicao: false,
      idEmpresa: null,
      permiteAlterarValorFipe: false,
      permiteAlterarValorCobertura: false,
      permiteAlterarValorConjunto: false,
      nomeConsultorPlaca: null,
      regionalConsultorPlaca: null,
      modalPlacaRecusada: false,
      codigoSituacaoPlaca: 0,
      permiteEditarPlaca: false,
      podeEditarVeiculo: false,
      showAtual: false,
      naoPodeEditarDataSaidaNF: false,
      modalAlteracaoDataNf: false,
      msgAlertaResetFotos: false,
      confirmacaoResetVistoria: false,
      modalInfoDataSaidaNf: false,
      listClassificacoes: [],
      modalGrupos: false,
      gruposEncontrados: [],
      veiculoSemGrupo: false,
      grupoEncontradoSelecionado: {},
      naoSalvarModeloVeiculo: false,
      listLocaisEstacionamento: [],
    };
  },
  methods: {
    verificaCamposAbrirEdicaoVeiculo() {
      const editarSemRestricoes =
        this.$can('Edição sem Restrição', 'Cotações') ||
        this.$can('Salvar proposta Independentemente de Status', 'Vistorias') ||
        this.$can('Editar proposta finalizada', 'Cotações');

      const propostaNaoCancelada = this.dadosProposta.idStatus != 2;
      const propostaNaoFinalizada = this.dadosProposta.idStatus != 4;
      const propostaNaoAguadandoAprovacao = this.dadosProposta.idStatus != 3;

      const podeEditarModeloVeiculo =
        editarSemRestricoes ||
        (propostaNaoCancelada &&
          propostaNaoFinalizada &&
          propostaNaoAguadandoAprovacao);

      if (podeEditarModeloVeiculo) {
        return false;
      } else {
        return true;
      }
    },

    liberaEdicaoVeiculo() {
      this.emitChangedForm('edicaoVeiculoliberada', true);
      this.showAtual = false;
      this.form.veiculo.anoFabricacao = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoModelo = null;
      // this.form.veiculo.codigoFipe = null;
      this.form.veiculo.codigoMarca = null;
      this.form.veiculo.codigoModelo = null;
      // this.form.veiculo.idGrupo = null;
      // this.form.veiculo.marca = null;
      this.form.veiculo.modelo = null;
      this.form.veiculo.resultFipe = null;
      this.form.veiculo.valorCobertura = null;
      this.form.veiculo.valorFipe = null;
      this.naoSalvarModeloVeiculo = true;
      this.podeEditarVeiculo = true;
    },

    definirTituloListaComplementos(item) {
      const temPlaca = item.placa ? item.placa + ' ' : '';
      const temChassi = item.chassi ? item.chassi + ' ' : '';
      const temDescricao = item.descricao ? item.descricao + ' -' : '';
      const temValorCobertura = item.valorCobertura ? item.valorCobertura : '';
      const temValorNf = item.valorNf ? item.valorNf : '';
      const temValor = ` Valor: R$ ${temValorCobertura || temValorNf}`;

      return `${temPlaca || temChassi}${temDescricao}${temValor}`;
    },
    definirSubTituloListaComplementos(item) {
      const temMarca = item.marca ? item.marca + ' ' : '';
      const temModelo = item.modelo ? item.modelo + ' ' : '';
      const temPlacaVinculo = item.placaVinculo
        ? `| Vinculo: ${item.placaVinculo}`
        : '';
      const temChassiVinculo = item.chassiVinculo
        ? `| Vinculo: ${item.chassiVinculo}`
        : '';
      const temVinculo = temPlacaVinculo || temChassiVinculo;

      return `${temMarca}${temModelo}${temVinculo}`;
    },
    AtualizarComplemento(dadosComplemento) {
      const { index, ...dadosComplementos } = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;

      this.form[tipo][index] = dadosComplementos;
      this.modalComplemento = false;
      this.complementoSelecionado = {};

      if (dadosComplementos.tipo !== 'agregado') {
        this.calcularCoberturaConjunto();
      }

      this.$emit('salvar');
    },
    excluirComplemento(dadosComplemento) {
      const { index, ...dadosComplementos } = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      const [complementoRemovido] = this.form[tipo].splice(index, 1);
      this[itemSelecionado] = {};

      const itemDeletado = `${tipo}Deletados`;
      this.form[itemDeletado].push(complementoRemovido);

      if (dadosComplementos.tipo != 'agregado') {
        this.calcularCoberturaConjunto();
      }
    },
    editarComplemento(dadosComplemento) {
      this.complementoSelecionado = dadosComplemento;
      this.resetFormComplemento = false;
      this.abrirModalComplemento();
    },
    adicionarComplemento(dadosComplementos) {
      const tipo = `${dadosComplementos.tipo}s`;
      this.form[tipo].push(dadosComplementos);

      this.modalComplemento = false;

      if (dadosComplementos.tipo === 'agregado') {
        this.validaImplementosAgregados = false;
      }

      if (dadosComplementos.tipo === 'implemento') {
        this.validaImplementosAgregados = false;
        this.calcularCoberturaConjunto();
      }

      this.msgValidacaoImplementoAgregado = '';
    },
    abrirModalComplemento() {
      this.modalComplemento = true;
      this.resetFormComplemento = false;
    },
    calcularCoberturaConjunto() {
      const _resultFipe =
        typeof this.form.veiculo.resultFipe === 'string'
          ? JSON.parse(this.form.veiculo.resultFipe)
          : this.form.veiculo.resultFipe;

      const temPrecoFipe = _resultFipe.preco;

      const precoFIPE =
        temPrecoFipe && typeof temPrecoFipe === 'string'
          ? parseFloat(_resultFipe.preco.replace('R$ ', '').replace('.', ''))
          : temPrecoFipe;

      const temValorNf = this.form.valorNf;
      const valorNF = temValorNf ? this.form.valorNf : 0;
      const veiculoZero = this.form.isZero;
      const preco = veiculoZero ? valorNF : precoFIPE;

      let totalValorImplemento = 0;
      let valorTotalConjunto = 0;

      this.form.implementos.forEach((implemento) => {
        const { valorCobertura, valorNf } = implemento;
        totalValorImplemento += valorNf > 0 ? valorNf : valorCobertura;
      });

      valorTotalConjunto = preco + totalValorImplemento;
      this.form.valorTotalConjunto = valorTotalConjunto;
      this.form.veiculo.valorCobertura = valorTotalConjunto;

      this.emitChangedForm('valorCobertura', this.form.veiculo.valorCobertura);
      this.emitChangedForm('valorTotalConjunto', this.form.valorTotalConjunto);
    },
    forcaAtualizacaoCota() {
      this.form.forcarAtualizarCotaManual = true;
      buscarFipeAtualizada;
      this.emitChangedForm(
        'forcarAtualizarCotaManual',
        this.form.forcarAtualizarCotaManual,
      );

      this.forcarRecalculodeCotaParticipacao = false;
      this.emitChangedForm(
        'forcarAtualizarCotaManual',
        this.form.forcarAtualizarCotaManual,
      );
    },
    buscarFipeAtualizada() {
      var resultDados = JSON.parse(
        this.dadosProposta.dadosVeiculo.resultadoFipe,
      );

      const temIdModeloAno = resultDados.hasOwnProperty('id_modelo_ano');
      const temCombustivel = resultDados.hasOwnProperty('combustivel');

      const _combustivel = temCombustivel
        ? resultDados.combustivel.toUpperCase()
        : this.form.veiculo.combustivel;

      const codigoTipoCombustivel = temIdModeloAno
        ? resultDados.id_modelo_ano.split('-')[1]
        : this.pegarTipoCombustivel(_combustivel);

      var formFipe = {
        codigoTabelaReferencia: null,
        codigoTipoVeiculo: resultDados.tipo,
        codigoMarca: resultDados.id_marca,
        ano: resultDados.id_modelo_ano,
        codigoTipoCombustivel,
        anoModelo: resultDados.ano_modelo,
        codigoModelo: resultDados.id_modelo,
      };

      service
        .post('Fipe', `ConsultarValorComTodosParametros`, formFipe)
        .then((res) => {
          if (!res.data.preco) {
            this.resetaModeloCompleto();
            this.form.veiculo.marca = null;

            this.resetaModeloCompleto();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'É necessário atualizar os dados FIPE, marca, ano e modelo.',
              color: 'warning',
            });

            return;
          }

          this.form.veiculo.resultFipe = res.data;
          this.form.veiculo.valorFipe = res.data.preco;

          this.calcularCoberturaConjunto();
          this.emitChangedForm('fipeAtualizada', res.data);
        });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    selecionaTipo() {
      if (!this.form.veiculo.idGrupo) return;

      var aux = this.grupos.find((x) => x.idGrupo == this.form.veiculo.idGrupo);
      if (!aux) {
        aux = { idTipoFipe: this.codTipoVeiculoAux };
      }
      this.grupoSelecionado = aux;

      this.form.veiculo.tipoVeiculo = aux.idTipoFipe;
      if (aux.idTipoFipe == 2) {
        this.exibeCilindrada = true;
      } else {
        this.exibeCilindrada = false;
      }
    },
    resetaModeloCompleto() {
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoFabricacao = null;
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
    },
    preencheMarca() {
      if (this.form.somenteAgregado) return;

      this.form.veiculo.marca = null;
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;
      this.marcas = [];
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];

      if (!this.form.veiculo.idGrupo) {
        return;
      }

      let obj = {
        idGrupo: {
          id: null,
        },
      };

      obj.idGrupo.id = this.form.veiculo.idGrupo;

      service
        .post('Cotacao', 'ConsultaMarcasModeloPorGrupo', obj)
        .then((res) => {
          if (res.data.length > 0) {
            this.isGrupoModelos = true;
            this.marcas = [];
            this.modelosAux = [];
            res.data.forEach((element) => {
              var aux = this.marcas.filter(
                (x) => x.value.id == element.idMarca,
              );
              var auxModelos = this.modelosAux.filter(
                (y) => y.value.id == element.idModelo,
              );

              if (aux.length == 0)
                this.marcas.push({
                  value: {
                    id: element.idMarca,
                    valor: element.marca,
                    isGrupoModelos: true,
                  },
                  text: element.marca,
                });

              if (!element.modelo && !element.idModelo) return;
              const id = element.idModelo ? String(element.idModelo) : '';

              if (auxModelos.length == 0)
                this.modelosAux.push({
                  idMarca: element.idMarca,
                  idTipo: element.idTipo,
                  value: {
                    id,
                    valor: element.modelo,
                    isGrupoModelos: true,
                  },
                  text: element.modelo,
                });
            });
            this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
          } else {
            this.isGrupoModelos = false;
            this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
          }
        });
    },
    async preencheModelo() {
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];

      if (!this.form.veiculo.marca) {
        this.form.veiculo.modelo = null;
        this.form.veiculo.anoFabricacao = null;
        return;
      }

      const { veiculo } = this.form;

      const temMarcaEmVeiculo = Boolean(veiculo.marca);

      if (temMarcaEmVeiculo) {
        this.form.veiculo.codigoMarca = this.form.veiculo.marca.id;
      }

      this.form.cilindradas = null;
      this.selecionaTipo();

      const temIsGrupoModelos = !temMarcaEmVeiculo
        ? false
        : veiculo.marca.isGrupoModelos
        ? true
        : false;

      if (!temIsGrupoModelos) {
        await this.buscaDadosFipe('ConsultarModelos', 'modelos', 'name', 'id');
      } else {
        this.modelos = this.modelosAux.filter(
          (x) => x.idMarca == this.form.veiculo.marca.id,
        );
      }
    },
    async preencheAnos() {
      if (!this.form.veiculo.modelo) {
        this.form.veiculo.anoFabricacao = null;
        this.preencheModelo();
        return;
      }

      this.form.veiculo.anoFabricacao = null;
      // this.anosModelo = [];
      this.form.cilindradas = null;

      if (this.form.veiculo.marca.isGrupoModelos == true) {
        var modeloAux = this.modelosAux.find(
          (x) => x.value.id == this.form.veiculo.modelo.id,
        );
        this.form.veiculo.tipoVeiculo = modeloAux.idTipo;
      }

      this.form.veiculo.codigoModelo = this.form.veiculo.modelo.id;
      this.anosModelo = [];
      await this.buscaDadosFipe(
        'ConsultarAnoModelo',
        'anosModelo',
        'name',
        'id',
      );

      var auxAnos = [];

      this.anosModelo.forEach((element) => {
        if (element.value) {
          const _temAPropValor = element.value.hasOwnProperty('valor');

          let ano = null;
          let combustivel = null;
          let codigoTipoCombustivel = null;

          if (_temAPropValor) {
            ano = element.value.valor.split(' ')[0];
            combustivel = element.value.valor.split(' ')[1];
            codigoTipoCombustivel = element.value.id.split('-')[1];
          } else {
            ano = element.value.ano;
            combustivel = element.value.combustivel;
            codigoTipoCombustivel = element.value.codigoTipoCombustivel;
          }

          auxAnos.push({
            value: {
              ano: ano,
              combustivel: combustivel,
              codigoTipoCombustivel: codigoTipoCombustivel,
            },
            text:
              ano == '32000'
                ? '0KM'
                : `${ano} ${combustivel ? combustivel : ''}`,
          });
        }
      });

      this.anosModelo = auxAnos;
    },
    selecionaAnoModelo() {
      if (!this.form.veiculo.anoGeral) {
        this.form.veiculo.anoFabricacao = null;
        this.preencheModelo();
        return;
      }

      this.form.veiculo.ano = this.form.veiculo.anoGeral.ano;
      this.form.veiculo.codigoTipoCombustivel =
        this.form.veiculo.anoGeral.codigoTipoCombustivel;
      this.form.veiculo.anoModelo = this.form.veiculo.anoGeral.ano;
      this.form.veiculo.combustivel = this.form.veiculo.anoGeral.combustivel;

      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;

      const _textAnoFabricao =
        this.form.veiculo.anoModelo == '32000'
          ? '0KM'
          : this.form.veiculo.anoModelo;

      const _anoModelo = this.form.veiculo.anoModelo - 1;
      const _anoAnterior =
        this.form.veiculo.anoModelo == '32000'
          ? {}
          : {
              value: _anoModelo,
              text: _anoModelo,
            };

      this.anosFabricacao = [
        {
          value: this.form.veiculo.anoModelo,
          text: _textAnoFabricao,
        },
        {
          ..._anoAnterior,
        },
      ];

      const _anosFabricacao = this.anosFabricacao.filter((ano) => ano.value);
      this.anosFabricacao = _anosFabricacao;

      this.buscaDadosFipe(
        'ConsultarModelosPorAno',
        'modelosPorAno',
        'name',
        'id',
      );
    },
    async buscaValorFipe() {
      if (
        this.form.veiculo.idGrupo &&
        this.form.veiculo.marca &&
        this.form.veiculo.modelo &&
        this.form.veiculo.anoModelo &&
        this.form.veiculo.anoFabricacao
      ) {
        this.form.veiculo.codigoModelo = Number(this.form.veiculo.modelo.id);
        await this.buscaDadosFipe(
          'ConsultarValorComTodosParametros',
          'form.veiculo.resultFipe',
          '',
          '',
        );
        await this.atualizarCotaParticipacao();
        this.podeEditarVeiculo = false;
        this.showAtual = true;
      }
    },
    async buscaDadosFipe(action, array, campoDescricao, campoPK) {
      return new Promise(async (resolve) => {
        this.$vs.loading();

        let _idMarca;
        let _idModelo;

        const idTipoCombustivel = this.pegarTipoCombustivel(
          this.form.veiculo.combustivel || this.form.combustivel,
        );
        let ano = this.form.veiculo.anoModelo + '-' + idTipoCombustivel;

        let codigoTipoCombustivel =
          this.form.veiculo.codigoTipoCombustivel || idTipoCombustivel;

        if (this.form.veiculo.marca) {
          _idMarca =
            this.form.veiculo.marca.id || this.form.veiculo.codigoMarca;
        }

        if (this.form.veiculo.modelo) {
          _idModelo =
            this.form.veiculo.modelo.id || this.form.veiculo.codigoModelo;
        }

        const typeOfanoGeral =
          this.form.veiculo.anoGeral &&
          typeof this.form.veiculo.anoGeral == 'object';
        let anoGeralTemCodCombustivel;

        if (typeOfanoGeral) {
          anoGeralTemCodCombustivel =
            this.form.veiculo.anoGeral.codigoTipoCombustivel;

          if (anoGeralTemCodCombustivel) {
            ano = this.form.veiculo.anoModelo + '-' + anoGeralTemCodCombustivel;
          }

          codigoTipoCombustivel = anoGeralTemCodCombustivel;
        }

        const formFipe = {
          codigoTabelaReferencia: this.codigoTabelaReferencia,
          codigoTipoVeiculo: this.form.veiculo.tipoVeiculo,
          codigoMarca: _idMarca,
          ano,
          codigoTipoCombustivel,
          anoModelo: this.form.veiculo.anoModelo,
          codigoModelo: _idModelo,
        };
        await service
          .post('Fipe', `${action}`, formFipe)
          .then((res) => {
            var arrayRes = res.data;

            this[array] = [];

            if (array == 'form.veiculo.resultFipe') {
              this.form.veiculo.resultFipe = arrayRes;
              this.form.veiculo.valorFipe = arrayRes.preco;
              this.emitChangedForm('valorFipe', this.form.veiculo.valorFipe);
              this.calcularCoberturaConjunto();
              this.emitChangedForm('fipeAtualizada', arrayRes);
              resolve();
              return;
            }

            if (array == 'marcas') {
              arrayRes.forEach((element) => {
                if (element['id']) {
                  this[array].push({
                    value: {
                      id: element['id'].toString(),
                      valor: element['name'],
                    },
                    text: element['name'],
                  });
                } else {
                  this[array].push(element);
                }
              });
            } else if (array == 'modelos') {
              this.modelos = [];
              arrayRes[0].forEach((element) => {
                this.modelos.push({
                  value: {
                    id: element['id'].toString(),
                    valor: element['name'],
                  },
                  text: element['name'],
                });
              });
              this.anosModelo = [];
              arrayRes[1].forEach((element) => {
                this.anosModelo.push({
                  value: {
                    ano: element.name.split(' ')[0],
                    combustivel: element.name.split(' ')[1],
                    codigoTipoCombustivel: element.id.split('-')[1],
                  },
                  text:
                    element.name.split(' ')[0] == 32000 ? '0KM' : element.name,
                });
              });
            } else if (array == 'anosModelo') {
              this.anosModelo = [];
              arrayRes.forEach((element) => {
                const text =
                  element.name.split(' ')[0] == 32000 ? '0KM' : element.name;
                this.anosModelo.push({
                  value: {
                    ano: element.name.split(' ')[0],
                    combustivel: element.name.split(' ')[1],
                    codigoTipoCombustivel: element.id.split('-')[1],
                  },
                  text,
                });
              });
            } else if (array == 'modelosPorAno') {
              this.modelos = [];
              arrayRes.forEach((element) => {
                this.modelos.push({
                  value: {
                    id: element['id'].toString(),
                    valor: element['name'],
                  },
                  text: element['name'],
                });
              });
            } else {
              arrayRes.forEach((element) => {
                if (array == 'codigoTabelaReferencia') {
                  this[array] = element[campoPK];
                } else
                  this[array].push({
                    value: {
                      id: element[campoPK],
                      valor: element[campoDescricao],
                    },
                    text: element[campoDescricao],
                  });
              });
            }
            resolve();
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Ocorreu um erro, por favor tente novamente!`,
              color: 'danger',
            });
          });
      });
    },
    buscarDicionarioCombustivelFipe() {
      service
        .post('dicionarios', 'buscar-dicionario-combustiveis-fipe', {})
        .then((res) => {
          this.dicionarioCombustivelFipe = res.data;
        })
        .catch((e) => {
          throw new Error(e);
        });
    },
    pegarTipoCombustivel(combustivel) {
      const codigoCombustivel = this.dicionarioCombustivelFipe.find((c) => {
        const _temNomeCombustivel =
          c.combustivel.toUpperCase() == combustivel.toUpperCase();

        if (_temNomeCombustivel) {
          return c;
        }

        const resultFipeIsString =
          typeof this.form.veiculo.resultFipe === 'string';

        const _dadosFipe = resultFipeIsString
          ? JSON.parse(this.form.veiculo.resultFipe)
          : this.form.veiculo.resultFipe;

        if (!this._isObjectEmpty(_dadosFipe)) {
          const _temNomeCombustivelNaFipe =
            c.combustivel.toUpperCase() == _dadosFipe.combustivel.toUpperCase();

          if (_temNomeCombustivelNaFipe) {
            return c;
          }
        }
      });

      return codigoCombustivel.codigo;
    },
    preencheForm() {
      let _form = {};
      const { idProposta: idPropostaFormulario } = this.formulario.dadosVeiculo;
      if (idPropostaFormulario) {
        this.form = this.formulario.dadosVeiculo;
        return;
      }

      if (!this.dadosProposta.idProposta) return;

      const {
        idProposta,
        idGrupo,
        implementos,
        agregados,
        valorTotalConjunto,
        isZero,
        nf,
        dataNf,
        valorNf,
        valorParticipacaoMinimo,
        valorCotaParticipacao,
        placaSubstituicao,
        agregado,
        implemento,
        somenteAgregado,
        dadosVeiculo: {
          valorCobertura,
          valorFipe,
          cilindradas,
          placa,
          renavam,
          chassi,
          km,
          qtdPortas,
          anoExercicioDut,
          estadoPneu,
          combustivel,
          cor,
          codigoMarca,
          codigoModelo,
          anoGeral,
          anoModelo,
          anoFabricacao,
          veiculoMarca: marca,
          veiculoModelo: modelo,
          codigoFipe,
          codTipoVeiculo,
          resultadoFipe: resultFipe,
          tipoCambio,
          numeroMotor,
          idClassificacao,
          idTipoEstacionamento,
        },
      } = this.dadosProposta;

      if (agregado) this.permiteAgregado = true;
      if (implemento) this.permiteImplemento = true;

      // const temcilindradas = cilindradas !== null ? cilindradas : '';

      _form = {
        idProposta,
        placa,
        placaSubstituicao,
        renavam,
        chassi,
        km,
        qtdPortas,
        anoExercicioDut,
        estadoPneu,
        combustivel,
        cor,
        cilindradas,
        valorTotalConjunto,
        isZero,
        nf,
        dataNf,
        valorNf,
        codTipoVeiculo,
        valorParticipacaoMinimo,
        valorCotaParticipacao,
        agregado,
        implemento,
        somenteAgregado,
        veiculo: {
          valorFipe,
          idGrupo,
          tipoVeiculo: codTipoVeiculo,
          codigoMarca,
          codigoModelo,
          anoGeral,
          anoModelo,
          anoFabricacao,
          combustivel,
          marca,
          modelo,
          codigoFipe,
          resultFipe,
          valorCobertura,
          tipoCambio,
          numeroMotor,
          idClassificacao,
          idTipoEstacionamento,
        },
        implementos: implementos || this.dadosProposta.implementos,
        agregados: agregados || this.dadosProposta.agregados,
      };

      this.form = {
        ...this.form,
        ..._form,
      };

      this.emitLoadedForm();
    },
    filtraGruposPorTipo() {
      const grupos = [...this.grupos];
      grupos.shift();
      const {
        idGrupo,
        nomeGrupo,
        dadosVeiculo: { codTipoVeiculo },
      } = this.dadosProposta;
      this.codTipoVeiculoAux = codTipoVeiculo;
      this.gruposPorTipo = grupos.filter(
        (grupo) => grupo.idTipoFipe === codTipoVeiculo,
      );
      let grupoSelecionado = grupos.find(
        (grupo) => grupo.id === idGrupo && grupo.label === nomeGrupo,
      );
      if (!grupoSelecionado) {
        this.gruposPorTipo.push({
          id: idGrupo,
          label: nomeGrupo + ' - Grupo Inativado',
        });
      }
      this.preencheGrupoDaProposta(grupoSelecionado, idGrupo);
    },
    preencheGrupoDaProposta(grupoSelecionado, idGrupo) {
      this.grupoSelecionado = null;

      this.form.veiculo.idGrupo = grupoSelecionado
        ? grupoSelecionado.id
        : idGrupo;

      this.grupoSelecionado = grupoSelecionado;

      if (grupoSelecionado && grupoSelecionado.permiteAgregado) {
        this.permiteAgregado = true;
      }
      if (grupoSelecionado && grupoSelecionado.permiteImplemento) {
        this.permiteImplemento = true;
      }

      this.preparaBuscaFipe();
      this.preparaBuscaMarcaProposta();
    },
    preparaBuscaFipe() {
      const { codigoMarca, codigoModelo, anoModelo } =
        this.dadosProposta.dadosVeiculo;

      this.form.veiculo.anoModelo = anoModelo;
      this.form.veiculo.codigoMarca = codigoMarca;
      this.form.veiculo.codigoModelo = codigoModelo;
    },
    async preparaBuscaMarcaProposta() {
      if (this.form.somenteAgregado) return;

      this.selecionaTipo();

      await this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
      this.preencheMarcaProposta();
    },
    preencheMarcaProposta() {
      if (this.dadosProposta.somenteAgregado) return;
      if (this.marcas.length === 0) return;

      const { codigoMarca, veiculoMarca } = this.dadosProposta.dadosVeiculo;
      this.form.veiculo.marca = this.marcas.find(
        (itemMarca) =>
          +itemMarca.value.id === codigoMarca && itemMarca.text == veiculoMarca,
      ).value;

      this.preparaBuscaAnoModeloProposta();
    },
    async preparaBuscaAnoModeloProposta() {
      await this.buscaDadosFipe(
        'ConsultarAnoModelo',
        'anosModelo',
        'name',
        'id',
      );
      this.preencheAnoModeloProposta();
    },
    preencheAnoModeloProposta() {
      const { anoModelo } = this.dadosProposta.dadosVeiculo;
      const _anoModelo = String(anoModelo);

      const _ano = this.anosModelo.find((ano) => {
        return ano.text.includes(_anoModelo);
      });

      this.form.veiculo.anoGeral = _ano
        ? _ano.text
        : _anoModelo == '32000'
        ? '0Km'
        : 'Selecione Ano Modelo';

      this.preparaBuscaModeloProposta();
      this.preparaBuscaAnoFabricacaoProposta();
    },
    async preparaBuscaModeloProposta() {
      await this.buscaDadosFipe(
        'ConsultarModelosPorAno',
        'modelosPorAno',
        'name',
        'id',
      );
      this.preencheModeloProposta();
    },
    preencheModeloProposta() {
      const { codigoModelo, veiculoModelo } = this.dadosProposta.dadosVeiculo;
      this.form.veiculo.modelo = this.modelos.find(
        (modelo) =>
          modelo.value.id.toString() === codigoModelo.toString() &&
          modelo.text === veiculoModelo,
      ).value;
      // this.preparaBuscaAnoModeloProposta();
    },
    preparaBuscaAnoFabricacaoProposta() {
      this.montarAnoFabricacao();
      this.preencheAnoFabricacaoProposta();
    },
    montarAnoFabricacao() {
      const _anoModelo =
        this.form.veiculo.anoModelo == '32000'
          ? '0KM'
          : this.form.veiculo.anoModelo;

      let anoAnterior =
        _anoModelo == '0KM'
          ? {}
          : {
              value: this.form.veiculo.anoModelo - 1,
              text: this.form.veiculo.anoModelo - 1,
            };

      this.anosFabricacao = [
        {
          value: this.form.veiculo.anoModelo,
          text: _anoModelo,
        },
        {
          ...anoAnterior,
        },
      ];
    },
    preencheAnoFabricacaoProposta() {
      const { anoFabricacao } = this.dadosProposta.dadosVeiculo;
      const _anoFabricacao = anoFabricacao == 32000 ? '0KM' : anoFabricacao;

      this.form.veiculo.anoFabricacao = this.anosFabricacao.find(
        (ano) => ano.text === _anoFabricacao,
      );
    },
    verificarPermissaoEditarGrupo() {
      return !this.$can('Editar Grupo na Edição da Proposta', 'Cotações');
    },
    emitLoadedForm() {
      this.$emit('loaded', { formulario: 'dadosVeiculo', ...this.form });
    },
    emitChangedForm(id, value, formulario = 'dadosVeiculo') {
      this.$emit('changed', { formulario, id, value });
    },
    async atualizarCotaParticipacao() {
      try {
        const idGrupo = this.form.veiculo.idGrupo
          ? this.form.veiculo.idGrupo
          : this.dadosProposta.idGrupo;

        const idMarca = this.form.veiculo.marca
          ? this.form.veiculo.marca.id
          : this.dadosProposta.dadosVeiculo.codigoMarca;

        const idModelo = this.form.veiculo.modelo
          ? this.form.veiculo.modelo.id
          : this.dadosProposta.dadosVeiculo.codigoModelo;

        const objBuscarCota = {
          idEmpresa: this.dadosProposta.idEmpresa,
          idGrupo,
          idMarca,
          idModelo,
          estado: this.estado,
          cidade: this.cidade,
        };

        const dadosCota = await service.post(
          'Cotacao',
          'buscarCotaParticipacaoAtualizada',
          objBuscarCota,
        );

        if (dadosCota) {
          const { valorCota, valorParticipacao } = dadosCota.data;

          this.form.valorCotaParticipacao = null;
          this.form.valorParticipacaoMinimo = null;

          this.form.valorCotaParticipacao = valorCota;
          this.form.valorParticipacaoMinimo = valorParticipacao;

          this.emitChangedForm(
            'valorCotaParticipacao',
            this.form.valorCotaParticipacao,
          );
          this.emitChangedForm(
            'valorParticipacaoMinimo',
            this.form.valorParticipacaoMinimo,
          );
        }
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível atualizar a Franquia, verifique os dados do veículo',
          color: 'danger',
        });
      }
    },
    temComplemento() {
      if (this.form.agregado && this.form.agregados.length === 0) {
        this.form.agregado = false;
      }

      if (this.form.implemento && this.form.implementos.length === 0) {
        this.form.implemento = false;
      }
    },
    excluirComplementos() {
      if (this.excluirAgregados) {
        this.form.agregadosDeletados = [...this.form.agregados];
        this.form.agregados = [];
        this.form.agregado = false;
        this.permiteAgregado = this.grupoSelecionado.permiteImplemento;

        this.modalConfirmExclusaoComplemento = false;
      }

      if (this.excluirImplementos) {
        this.form.implementosDeletados = [...this.form.implementos];

        this.emitChangedForm(
          'implementosDeletados',
          this.form.implementosDeletados,
        );
        this.form.implementos = [];
        this.permiteImplemento = this.grupoSelecionado.permiteImplemento;

        this.emitChangedForm('implementos', this.form.implementos);
        this.form.implemento = false;

        const _marca = this.form.veiculo.marca;
        const _modelo = this.form.veiculo.modelo;
        const _anoGeral = this.form.veiculo.anoGeral;
        const _anoFabricacao = this.form.veiculo.anoFabricacao;

        const temDadosFipeVeiculo =
          _marca && _modelo && _anoGeral && _anoFabricacao;

        if (temDadosFipeVeiculo) {
          this.calcularCoberturaConjunto();
        } else {
          this.form.veiculo.marca = null;
          this.emitChangedForm('marca', this.form.veiculo);

          this.form.veiculo.modelo = null;
          this.emitChangedForm('modelo', this.form.veiculo);

          this.form.veiculo.anoGeral = null;
          this.emitChangedForm('anoGeral', this.form.veiculo);

          this.form.veiculo.anoFabricacao = null;
          this.emitChangedForm('anoFabricacao', this.form.veiculo);
        }

        this.modalConfirmExclusaoComplemento = false;
        this.emitLoadedForm();
      }
    },
    restauraGrupo() {
      this.form.veiculo.idGrupo = this.idGrupoAux;
    },
    verificaSeGrupoPermiteComplementos(idGrupo) {
      if (!idGrupo) return;

      const _grupoSelecionado = this.gruposPorTipo.find(
        ({ id }) => id === idGrupo,
      );

      const { permiteAgregado, permiteImplemento } = _grupoSelecionado;
      const temAgregado = this.form.agregados.length;
      const temImplemento = this.form.implementos.length;

      if (!permiteAgregado && temAgregado) {
        this.excluirAgregados = true;

        // abre modal confirmar exclusão de agregado
        this.modalConfirmExclusaoComplemento = true;
      }

      if (!permiteImplemento && temImplemento) {
        this.excluirImplementos = true;
        // abre modal confirmar exclusão de implementos
        this.modalConfirmExclusaoComplemento = true;
      }
    },
    chassiToUpperCase(chassi) {
      if (chassi) {
        this.form.chassi = chassi.toUpperCase();
      }
    },
    verificaPlacaSubstituicao() {
      this.form.placa = this.form.placa.toUpperCase();
      this.form.placaSubstituicao = this.form.placaSubstituicao.toUpperCase();
      if (this.form.placaSubstituicao === this.form.placa) {
        this.modalPlacaSubstituicao = true;
      } else {
        this.emitChangedForm('placaSubstituicao', this.form.placaSubstituicao);
      }
    },
    resetPlacaSubstituicao() {
      this.form.placaSubstituicao = null;
      this.modalPlacaSubstituicao = false;
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
    async getEmpresa() {
      const _token = localStorage.getItem('user-token');
      let id_empresa = jwt.decode(_token).id_empresa;

      if (!id_empresa) {
        id_empresa = !id_empresa
          ? this.$route.params.idEmpresa
          : this.$route.query.idEmpresa;
      }

      this.idEmpresa = id_empresa;
    },
    _isObjectEmpty(value) {
      const isEmpty =
        value && Object.keys(value).length && value.constructor === Object;

      return !isEmpty;
    },
    verificarPermissaoAlteraValor() {
      if (this.dadosProposta.somenteAgregado == false) {
        return;
      }

      const naoPodeAlterarValor = this.$can(
        'Não pode editar valores da proposta',
        'Cotações',
      );

      if (naoPodeAlterarValor) {
        this.permiteAlterarValorCobertura = true;
        this.permiteAlterarValorFipe = true;
        this.permiteAlterarValorCobertura = true;
      }
    },
    async _consultaPlaca(event) {
      try {
        const { value: placa } = event.target;
        const placaPropostaAtual =
          this.dadosProposta.dadosVeiculo.placa == placa;
        const placaTamanhoInvalido = placa.length < 8;

        if (!placa || placaPropostaAtual || placaTamanhoInvalido) {
          this.$emit('permitSalvar', 0);
          this.$vs.loading.close();
          return;
        }

        this.$vs.loading();
        const dadosConsultaPlaca = await consultaPlaca({
          tipoIdentificado: 'placa',
          identificador: this.form.placa,
          idEmpresa: this.form.idEmpresa,
          somenteAgregado: this.form.somenteAgregado,
          permitePlacaRepetida: this.permitePlacaRepetida,
          idProposta: this.form.idProposta,
        });

        const _codigoSituacao =
          dadosConsultaPlaca === true ? 0 : dadosConsultaPlaca.codigoSituacao;
        this.$emit('permitSalvar', _codigoSituacao);
        this.exibirAlertaPlaca(dadosConsultaPlaca);

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.form.placa = '';

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao buscar placa, tente novamente',
          color: 'danger',
        });
      }
    },
    exibirAlertaPlaca(dadosConsultaPlaca) {
      if (!dadosConsultaPlaca && dadosConsultaPlaca.codigoSituacao == '0') {
        return;
      }

      const {
        nomeConsultorPlaca,
        regionalConsultorPlaca,
        modalPlacaRecusada,
        codigoSituacao,
      } = dadosConsultaPlaca;

      this.nomeConsultorPlaca = nomeConsultorPlaca;
      this.regionalConsultorPlaca = regionalConsultorPlaca;
      this.modalPlacaRecusada = modalPlacaRecusada;
      this.codigoSituacaoPlaca = codigoSituacao;

      return;
    },
    verificaPermissaoAlterarDataNf() {
      const _naoPodeEditarDataSaidaNf = this.$can(
        'Não pode editar data de saída e valor da NF',
        'Cotações',
      );

      this.naoPodeEditarDataSaidaNF = _naoPodeEditarDataSaidaNf;
    },
    keyMonitorDataNF() {
      if (this.form.dataNf.length == 0) {
        this.msgAlertaResetFotos = true;
        this.modalAlteracaoDataNf = true;
      }

      if (this.form.dataNf.length == 10 && this.msgAlertaResetFotos) {
        const { dataValida, exibirAlerta } = this.validarDataSaidaNf();

        if (exibirAlerta) {
          return;
        }

        this.confirmacaoResetVistoria = true;
        this.modalAlteracaoDataNf = true;
      }
    },
    resetFotosVistoria() {
      // this.$vs.loading();

      if (this.msgAlertaResetFotos && this.confirmacaoResetVistoria) {
        this.$emit('salvar');

        this.$vs.loading.close();
      }

      this.modalAlteracaoDataNf = false;
      this.$vs.loading.close();
    },
    resetTrocaDataNF() {
      this.modalAlteracaoDataNf = false;
      this.msgAlertaResetFotos = false;
      this.confirmacaoResetVistoria = false;
      this.form.dataNf = this.dadosProposta.dataNf;
    },
    validarDataSaidaNf() {
      let dataValida = false;
      let btnDisabled = 1;
      this.$emit('permitSalvar', btnDisabled);

      const dataNfValida = this.form.dataNf.length == 10;
      let exibirAlerta = false;

      if (dataNfValida) {
        dataValida = dateConversion.verificarSaidaNotaFiscal(this.form.dataNf);

        btnDisabled = dataValida ? 0 : 1;
        this.$emit('permitSalvar', btnDisabled);

        if (dataValida) {
          return { dataValida, exibirAlerta };
        }
      }

      exibirAlerta = dataNfValida && !dataValida;
      this.modalInfoDataSaidaNf = exibirAlerta ? true : false;

      return { dataValida, exibirAlerta };
    },

    async buscaClassificacoes() {
      try {
        const result = await service.post(
          'classificacoes',
          'listClassificacoes',
          {},
        );
        this.listClassificacoes = result.data;
      } catch (error) {
        throw new Error(error);
      }
    },

    /**
     * Finalizes the vehicle edition.
     * This function emits a change event to indicate that vehicle editing is no longer allowed
     * and triggers a search for the FIPE value.
     *
     * @function
     * @name concluirEdicaoVeiculo
     * @memberof YourClassName
     * @returns {void}
     */
    concluirEdicaoVeiculo() {
      this.emitChangedForm('edicaoVeiculoliberada', false);
      this.buscaValorFipe();
    },

    /**
     * Asynchronously selects and retrieves FIPE groups for a given vehicle model.
     * This function performs various checks and calls to external services to determine
     * the appropriate FIPE groups based on the provided vehicle information.
     *
     * @async
     * @function
     * @name selecionaGruposFipe
     * @memberof YourClassName
     * @returns {Promise<void>} A promise that resolves once the FIPE groups are selected.
     */
    async selecionaGruposFipe() {
      if (this.form.veiculo.anoFabricacao) {
        this.naoSalvarModeloVeiculo = true;
      }
      const modelo = this.form.veiculo;
      const importado = await functions.verificaVeiculoImportado(
        this.form.chassi,
        this.idEmpresa,
      );

      const objBuscaGrupo = {
        idEmpresa: this.idEmpresa,
        idMarca: modelo.marca.id,
        idModelo: modelo.modelo.id,
        tipo: modelo.tipoVeiculo,
        anoFabricacao: modelo.anoFabricacao,
        anoModelo: modelo.anoModelo,
        importado: this.verificaEmpresa() ? importado : null,
      };

      const objGrupos = await service.post(
        'CotacaoAberta',
        'buscaGrupoMarcaModelo',
        objBuscaGrupo,
      );

      if (objGrupos.data.length === 0) {
        this.form.veiculo.anoFabricacao = null;
        this.form.veiculo.anoGeral = null;
        this.form.veiculo.anoModelo = null;
        this.form.veiculo.modelo = null;
        this.naoSalvarModeloVeiculo = true;
        this.veiculoSemGrupo = true;
      }

      if (objGrupos.data.length === 1) {
        this.form.veiculo.idGrupo = objGrupos.data[0].id;
        this.form.veiculo.labeGrupo = objGrupos.data[0].label;
        this.naoSalvarModeloVeiculo = false;
      }
      if (objGrupos.data.length > 1) {
        this.gruposEncontrados = objGrupos.data;
        this.grupoEncontradoSelecionado = objGrupos.data[0];
        this.naoSalvarModeloVeiculo = true;
        this.modalGrupos = true;
      }
      this.$vs.loading.close();
    },

    /**
     * Selects a FIPE group from the list of found groups.
     * This function updates the form with the selected group's ID and label,
     * and closes the modal displaying the available groups.
     *
     * @function
     * @name selecionaGrupoEncontrado
     * @memberof YourClassName
     * @returns {void}
     */
    selecionaGrupoEncontrado() {
      this.form.veiculo.idGrupo = this.grupoEncontradoSelecionado.id;
      this.form.veiculo.labeGrupo = this.grupoEncontradoSelecionado.label;
      this.naoSalvarModeloVeiculo = false;
      this.modalGrupos = false;
    },
    verificaCamposParaEdicao() {
      return (
        !this.form.veiculo.anoFabricacao ||
        !this.form.veiculo.anoModelo ||
        !this.form.veiculo.anoGeral ||
        !this.form.veiculo.modelo ||
        !this.form.veiculo.marca ||
        !this.form.veiculo.idGrupo ||
        this.naoSalvarModeloVeiculo
      );
    },

    async buscaDadosTiposEstacionamento() {
      try {
        this.$vs.loading();
        const result = await estacionamentoService.buscar();
        this.listLocaisEstacionamento = result.data.map((elem) => {
          return { id: elem.idTipoEstacionamento, label: elem.nome };
        });
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar os locais de estacionamento, tente novamente',
          'Atenção',
          'danger',
          5000,
        );
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.permiteEditarPlaca = this.$can(
      'Não permite editar placa e chassi',
      'Cotações',
    );
    this.verificarPermissaoAlteraValor();
    this.verificaPermissaoAlterarDataNf();

    await this.getEmpresa();
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.verificarPermissaoEditarGrupo();
    this.buscarDicionarioCombustivelFipe();
    this.buscaClassificacoes();
    this.buscaDadosTiposEstacionamento();
  },
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
